module.exports = __webpack_public_path__ + "images/cv_bulk_btn_25297005a372f4f181a5a8cb9aa69588.png";